import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import Title from '../../../components/title/Title';
import { Spinner, Modal, Button, Row, Col, Alert } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrashAlt, faEdit } from '@fortawesome/free-regular-svg-icons';
import ConfirmModal from '../../../components/modal/confirmModal/ConfirmModal';
import { BE_URL, httpGet, httpPut, httpDelete } from '../../../http';
import './Admins.css';

const TextBox = (props) => {
    return(
        <input className='admins-text-box' type={props.type} name={props.name} value={props.value} onChange={props.onChange} required />
    );
}

const Field = (props) => {
    return(
        <div className='admins-field'>
            <div className='admins-field-name'>{ props.label }</div>
            <div><TextBox type={props.type} name={props.name} value={props.value} onChange={props.onChange} /></div>
            <div className='admins-field-hint'>{ props.hint }</div>
        </div>
    );
}

const EditModal = (props) => {
    if(props.show){
        return(
            ReactDOM.createPortal(
                <Modal size="xl" show={props.show} onHide={props.onClose} onShow={() => {}}>
                    <Modal.Header closeButton>
                        <h3>{props.title}</h3>
                    </Modal.Header>
                    <Modal.Body className="modal-body">
                        { props.admin.error &&
                            <>
                                <br />
                                <Alert variant='danger'>{ props.admin.errorMsg }</Alert>
                            </>
                        }
                        <form className='signup-form' >
                            <Field type='text' label='Nombre(*)' hint='Nombre del usuario' name='nombre' value={props.admin.nombre} onChange={props.onChange} />
                            <Field type='email' label='Correo electrónico(*)' hint='Dijite su correo electrónico' name='email' value={props.admin.email} onChange={props.onChange} />
                            <Field type='password' label='Contraseña(*)' hint='Dijite una contraseña' name='password1' value={props.admin.password1} onChange={props.onChange} />
                            <Field type='password' label='Repita la contraseña(*)' hint='Dijite de nuevo la contraseña' name='password2' value={props.admin.password2} onChange={props.onChange} />
                        </form>
                    </Modal.Body>
                    <Modal.Footer>
                        <Row>
                            <Col>
                                <Button onClick={props.onAccept}>Aceptar</Button>
                            </Col>
                            <Col>
                                <Button onClick={props.onClose}>Cancelar</Button>
                            </Col>
                        </Row>
                    </Modal.Footer>
                </Modal>
                , document.getElementById('modal'))            
        );
    } else {
        return (
            null
        );
    }
}

const Admins = (props) => {

    const [ estado, setEstado ] = useState({
        empresa: {
            nit: '',
            razonSocial: '',
            nombreAlterno: ''
        },
        admin: {
            email: '',
            nombre: '',
        },
        loading: true,
        error: {}
    });

    const [ admins, setAdmins ] = useState({
        data: [
            {
                id: '1',
                email: '94481222',
                nombre: 'Alexander Lopez',
                createAt: '2021-03-19 15:03:00',
                state: true
            },
            {
                id: '2',
                email: '94481222',
                nombre: 'Alexander Lopez',
                createAt: '2021-03-19 15:03:00',
                state: true
            },
        ],
        loading: false,
        error: {},
        showModal: false,
        showEditModal: false,
        showNewModal: false
    });

    const [ admin, setAdmin ] = useState({
        nombre: '',
        email: '',
        password1: '',
        password2: '',
        error: false,
        errorMsg: '',
        loading: false
    });

    const [ adminOld, setAdminOld ] = useState({
        nombre: '',
        email: '',
        password1: '',
        password2: ''
    });

    const [ showEditModal, setShowEditModal ] = useState(false);
    const [ showNewModal, setShowNewModal ] = useState(false);
    const [ showRemoveModal, setShowRemoveModal ] = useState(false);

    useEffect(() => {
        setEstado(JSON.parse(sessionStorage.getItem('estado')));
        setEstado({
            ...estado,
            admin: JSON.parse(sessionStorage.getItem('adminUser'))
        });

        getAdmins();

    }, []);

    const getAdmins = () => {
        setAdmins({
            ...admins,
            loading: true
        });
        httpGet(BE_URL + '/ProveedoresWS/api/AdminUser').then(
            resp => {
                console.log(resp.data);
                setAdmins({
                    ...admins,
                    data: resp.data,
                    loading: false
                })
            }
        ).catch(
            error => {
                console.log(error);
                setAdmins({
                    ...admins,
                    loading: false
                });
            }
        );

    }

    const handleRemove = (e, admin) => {
        setAdmin({
            ...admin,
            id: admin.id,
            nombre: admin.nombre,
            email: admin.email
        });
        setShowRemoveModal(true);
    }

    const closeRemoveModal = () => {
        setShowRemoveModal(false);
    }
    
    const closeEditModal = () => {
        setShowEditModal(false);
    }

    const closeNewModal = () => {
        setShowNewModal(false);
    }

    const handleEdit = (e, admin) => {
        setAdmin({
            ...admin,
            id: admin.id,
            nombre: admin.nombre,
            email: admin.email
        });

        setAdminOld({
            ...admin,
            id: admin.id,
            nombre: admin.nombre,
            email: admin.email
        });

        setShowEditModal(true);
    }

    const handleNew = (e, id) => {
        setAdmin({
            ...admin,
            id: null,
            nombre: '',
            email: ''
        });
        setShowNewModal(true);
    }

    const handleChange = (e) => {
        setAdmin({
            ...admin,
            [e.target.name]: e.target.value
        })
    }

    const valEmail = async (email) => {
        const val = await httpGet(BE_URL + '/ProveedoresWS/api/AdminUser/val/email/' + email);
        return val;
    }

    const handleSave = async () => {

        console.log("EMAIL: " + admin.email + " - " + adminOld.email);
        if (admin.email !== adminOld.email){
            let vEmail = await valEmail(admin.email);
            console.log("vEMAIL");
            console.log(vEmail);
            if (vEmail.data.resp) {
                setAdmin({
                    ...admin,
                    error: true,
                    errorMsg: 'El Correo electrónico ya se encuentra registrado.',
                    loading: false
                });
                return 0;
            }
        }

        if (admin.password1 !== admin.password2){
            setAdmin({
                ...admin,
                error: true,
                errorMsg: 'Las contraseñas no coinciden.',
                loading: false
            });
            return 0;
        }

        let data = {
            id: admin.id,
            nombre: admin.nombre,
            email: admin.email,
            password1: admin.password1
        }

        if((admin.password1 === undefined) || (admin.password1 === null)){
            data.password1 = '';
        }

        httpPut(BE_URL + '/ProveedoresWS/api/AdminUser', data).then(
            resp => {
                setShowEditModal(false);
                setShowNewModal(false);
                getAdmins();
            }
        ).catch(
            error => {
                console.log(error);
                setShowEditModal(false);
                setShowNewModal(false);
            }
        );
    }

    const handleRemoveAdmin = () => {
        httpDelete(BE_URL + '/ProveedoresWS/api/AdminUser/' + admin.id).then(
            resp => {
                setShowRemoveModal(false);
                getAdmins();
            }
        ).catch(
            error => {
                console.log(error);
                setShowRemoveModal(false);
            }
        );
    }

    return(
        <div className='page-container'>
            <Title>Administracion de usuarios administradores</Title>
            <div className='page-body'>
            </div>
            <div>
                { admins.loading ?
                <div className='loading-spinner'>
                        <Spinner animation="border" variant="primary" />
                </div>
                :
                <div>
                    <div style={{ width: '100%', textAlign: 'right' }}>
                        <Button type="button" onClick={handleNew} >Nuevo...</Button>
                    </div>
                    <table className='info-table'>
                        <thead>
                            <tr>
                                <th>NOMBRE</th>
                                <th>CORREO ELECTRÓNICO</th>
                                <th>FECHA DE CREACION</th>
                                <th>MODIFICAR</th>
                                <th>ELIMINAR</th>
                            </tr>
                        </thead>
                        <tbody>
                            { 
                                admins.data.map(
                                    admin => {
                                        return(
                                            <tr key={admin.id}>
                                                <td>{ admin.nombre }</td>
                                                <td>{ admin.email }</td>
                                                <td>{ admin.createAt }</td>
                                                <td><div className='visible-icon-container'><Link style={{ color: 'black' }} onClick={(e) => { handleEdit(e, admin) }}><FontAwesomeIcon className='view-icon' icon={faEdit} /></Link></div></td>
                                                <td><div className='pdf-icon-container'><Link style={{ color: 'red' }} onClick={(e) => { handleRemove(e, admin) }} ><FontAwesomeIcon className='view-icon' icon={faTrashAlt} /></Link></div></td>
                                            </tr>
                                        );
                                    }
                                )
                            }
                        </tbody>
                    </table>
                </div>
                }
            </div>
            <ConfirmModal title='Eliminar usuario admin' show={ showRemoveModal } onAccept={ handleRemoveAdmin } onClose={ closeRemoveModal }>¿Desea eliminar el usuario: { admin.nombre }?</ConfirmModal>
            <EditModal title='Modificar usuario administrador' show={ showEditModal } onAccept={ handleSave } onClose={ closeEditModal } admin={admin} onChange={handleChange} />
            <EditModal title='Crear usuario administrador' show={ showNewModal } onAccept={ handleSave } onClose={ closeNewModal } admin={admin} onChange={handleChange} />
        </div>
    );
}

export default Admins;